export enum EIdentificationType {
  DNI_NIF = 1,
  Pasaporte = 2,
  TResidencia = 3,
  PResidencia = 4,
  NIE = 6,
  NIFRepresentanteMenor = 7,
  CIF = 9,
  NIFMenor = 10
}
